import { Outlet } from "react-router-dom";

const CorporateActions = () => {
  return <Outlet />;
};

export default CorporateActions;
